import AubreyO from '../assets/people/Aubrey_O.jpg';
import BillM from '../assets/people/Bill_M.jpg';
import BrianS from '../assets/people/Brian_S.jpg';
import BrendonW from '../assets/people/Brendon_W.jpg';
import ChrisF from '../assets/people/Chris_F.jpg';
import ChristinaL from '../assets/people/Christina_L.jpg';
import DavidK from '../assets/people/David_K.jpg';
import DustinC from '../assets/people/Dustin_C.jpg';
import EliM from '../assets/people/Eli_M.jpg';
import EricL from '../assets/people/Eric_L.jpg';
import GriffinQ from '../assets/people/Griffin_Q.jpg';
import JasonC from '../assets/people/Jason_C.png';
import JillieneH from '../assets/people/Jilliene_H.jpg';
import JustinF from '../assets/people/Justin_F.jpg';
import KyleB from '../assets/people/Kyle_B.jpg';
import MarcoA from '../assets/people/Marco_A.jpg';
import TrevorS from '../assets/people/Trevor_S.jpg';
import AylaN from '../assets/people/Ayla_N.jpg';


export default [
  {
    key: 'jillieneh',
    image: JillieneH,
    name: 'Jilliene Helman',
    title: 'Chief Executive Officer',
    bio: 'Jilliene Helman is Chief Executive Officer of RealtyMogul and its wholly owned subsidiaries, RM Manager, RealtyMogul Commercial Capital, RM Adviser, Mogul Securities and RM Technologies. In these capacities, she has structured and approved investments with property values over $2 billion and is a pioneer in real estate crowdfunding. Jilliene is a Certified Wealth Strategist and holds FINRA Series 24, 7 and 63 licenses.',
    leadership: true,
  },
  {
    key: 'chrisf',
    image: ChrisF,
    name: 'Christopher Fraley',
    title: 'Chief Investment Officer',
    bio: 'Christopher Fraley is Chief Investment Officer for RealtyMogul, overseeing underwriting, closing and asset management for the firm’s debt and equity investments. Mr. Fraley has over 20 years of experience in commercial real estate finance, including sourcing transactions and negotiating complex joint venture equity partnerships. From 2006-2013, Mr. Fraley sat on the Investment Committee for Rockwood Capital, a privately held real estate investment and advisory firm with more than $8 billion in assets under management.',
    leadership: true,
  },
  {
    key: 'brians',
    image: BrianS,
    name: 'Brian Sigler',
    title: 'Managing Director, Investor Relations',
    bio: 'Brian Sigler is Managing Director of Investor Relations with responsibility for managing client relationships. In this capacity, he has overseen $200+ million in investment offerings and is FINRA Series 7 and 63 licensed. Brian has over 15 years of investment management and finance experience, most notably working with high net worth individuals and family offices at Morgan Stanley and Barclays.',
    leadership: true,
  },
  {
    key: 'billm',
    image: BillM,
    name: 'Bill McKnight',
    title: 'SVP, Marketing & Technology',
    bio: 'Bill McKnight is the Senior Vice President of Marketing and Technology with responsibility for corporate marketing, customer relationship management, and technology. He oversees a team charged with designing, testing and implementing effective marketing strategies and launching new website features. Mr. McKnight has extensive general management, product management, technology and business development experience with B2B/B2C platform and was formerly the General Manager for Rent.com and an SVP at Apartment List.',
    leadership: true,
  },
  {
    key: 'dustinc',
    image: DustinC,
    name: 'Dustin Currie',
    title: 'VP, Engineering',
    bio: 'Dustin Currie is the Vice President of Engineering for RealtyMogul, focused on leading and growing RealtyMogul technology. He oversees a team charged with developing, testing and launching new website features. Prior to RealtyMogul, Dustin consulted for, designed, and built software for FinTech startups and media conglomerates.',
    leadership: true,
  },
  {
    key: 'aylan',
    image: AylaN,
    name: 'Ayla Nazli',
    title: 'VP, Legal & Chief Compliance Officer',
    bio: 'Ayla Nazli is Vice President, Legal & Chief Compliance Officer and advises RealtyMogul and its wholly-owned subsidiaries on corporate and securities law and compliance matters. Prior to RealtyMogul, Ms. Nazli served as Senior Counsel at Transamerica, and prior to that, she was an Associate at K&L Gates LLP. Ms. Nazli earned her J.D. from the University of Pennsylvania Law School, and her B.A. in Economics from Emory University.',
    leadership: true,
  },
  {
    key: 'aubreyo',
    image: AubreyO,
    name: 'Aubrey Oesterle',
    title: 'VP, Operations',
    bio: 'Aubrey Oesterle is Vice President of Operations with responsibility for overseeing marketplace transactions and operational processes across the RealtyMogul technology platform. Ms. Oesterle has over 8 years of experience developing operational processes across real estate and technology firms, with experience in loan servicing, commercial leasing and acquisitions, investment management, and technology project development.',
    leadership: true,
    joined: 2015,
  },
  {
    key: 'marcoa',
    image: MarcoA,
    name: 'Marco Allegro',
    title: 'Controller',
    bio: 'Marco Allegro is Controller and is responsible for accounting and financial reporting. Mr. Allegro holds a Bachelor of Science in Economics and has experience in both public and private accounting across various industries, such as financial services, legal, and real estate.',
    leadership: true,
    joined: 2017,
  },
  {
    key: 'kyleb',
    image: KyleB,
    name: 'Kyle Barnas',
    title: 'AVP, Commercial Real Estate',
    bio: 'Kyle Barnas is an Assistant Vice President on the commercial real estate team responsible for sourcing, underwriting and closing direct acquisitions and JV equity investment opportunities. Mr. Barnas has 10 years of professional experience encompassing brokerage, banking, and underwriting. Prior to RealtyMogul, Kyle was an Associate at Morgan Stanley and spent time at Hughes Marino and CBRE.',
    leadership: true,
    joined: 2015,
  },
  {
    key: 'justinf',
    image: JustinF,
    name: 'Justin Fromm',
    title: 'Vice President, Commercial Real Estate',
    bio: 'Justin Fromm is a Vice President on the commercial real estate team responsible for sourcing, underwriting and closing JV equity and preferred equity investment opportunities. Prior to RealtyMogul, Justin worked for Bellwether Asset Management, an exclusive consultant to Oaktree Capital, where he assisted in the asset management of nearly $2 billion of outstanding equity in over $3 billion of real estate related investments. Justin holds an MBA from University of Southern California and a BA from Duke University.',
    leadership: true,
  },
  {
    key: 'ericl',
    image: EricL,
    name: 'Eric Levy',
    title: 'Vice President, Portfolio Manager',
    bio: 'Eric Levy is a Vice President and Portfolio Manager with responsibility for portfolio and asset management for debt and equity assets held by MogulREIT I and MogulREIT II. Mr. Levy has over 8 years of commercial real estate experience, including asset management across all asset classes, construction management and investor relations. Prior to RealtyMogul, he worked for World Class Capital Group.',
    leadership: true,
  },
  {
    key: 'davidk',
    image: DavidK,
    name: 'David Karle',
    title: 'Vice President, Asset Management & Chief Sustainability Officer',
    bio: 'David Karle is a Vice President, Asset Management & Chief Sustainability Officer with responsibility for overseeing asset management for the firm’s debt and equity investments. David has over 10 years of commercial real estate experience, most recently working in originations at Mesa West Capital, a privately held portfolio lender with a capital base of more than $4.0 billion, underwriting and closing on over $500MM of transactions.',
    leadership: true,
  },
  {
    key: 'elim',
    image: EliM,
    name: 'Eli Macanian',
    title: 'Vice President, Asset Management',
    bio: 'Eli Macanian is a Vice President with responsibility for overseeing asset management for the firm’s debt and equity investments. Mr. Macanian has over 8 years of commercial real estate asset management experience, including equity and debt investments across multiple property types. Prior to RealtyMogul, he worked in asset management and acquisitions at Dunkirk Realty.',
    leadership: true,
  },
  {
    key: 'jasonc',
    image: JasonC,
    name: 'Jason Conklin',
    title: 'Senior Director, Investor Relations',
    bio: 'Jason Conklin is a Director of Investor Relations with responsibility for managing client relationships. Mr. Conklin has been in the real estate investment space since 2003, has been involved with securities since 2013 and is FINRA series 7 and 63 certified. Prior to joining RealtyMogul, he was an Investor Education Manager, Adviser and Registered Representative with TD Ameritrade.',
    leadership: true,
    joined: 2017,
  },
  {
    key: 'griffinq',
    image: GriffinQ,
    name: 'Griffin Quick',
    title: 'Director, Investor Relations',
    bio: 'Griffin Quick is a Director on the Investor Relations team with responsibility for managing client relationships. Mr. Quick has over 3 years of experience in both public and private equity investments, and is FINRA Series 7 and 63 certified. He earned his bachelor’s degree in Political Science from UC Davis in 2014 and is currently pursuing his MBA at the University of Utah. Prior to RealtyMogul, he worked as a Financial Advisor for Morgan Stanley.',
    leadership: true,
  },
  {
    key: 'trevors',
    image: TrevorS,
    name: 'Trevor Sybertz',
    title: 'Director, Investor Relations',
    bio: 'Trevor Sybertz is a Director of Investor Relations with responsibility for managing client relationships. Mr. Sybertz has over 5 years of experience in commercial real estate and capital markets and is FINRA Series 7 and 63 certified. Prior to RealtyMogul, he was an Assistant Vice President of Institutional Equity Sales at KBW with an emphasis on commercial mortgage REITs and international equities.',
    leadership: true,
  },
  {
    key: 'brendonw',
    image: BrendonW,
    name: 'Brendon Williams',
    title: 'Senior Investment Representative',
    bio: 'Brendon Williams is a Senior Investment Representative on the Investor Relations team with responsibility for managing client relationships. Brendon is FINRA Series 7, 63, & 65 licensed and has over 20 years of investment management, capital markets, and finance experience, most notably working with high net worth individuals and institutions at JP Morgan, Credit Suisse, UBS, and Citigroup.',
    leadership: true,
  },
  {
    key: 'christinal',
    image: ChristinaL,
    name: 'Christina Lim-Sandoval',
    title: 'Creative Director',
    bio: undefined,
    leadership: false,
    joined: 2017,
  },
];
